var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNavPerfil = function SvgNavPerfil(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "nav_perfil_svg__Capa_2",
    viewBox: "0 0 29.47 34.07"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "nav_perfil_svg__Capa_1-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.74 17.03c4.5 0 8.14-3.65 8.14-8.14S19.23.75 14.74.75 6.6 4.4 6.6 8.89s3.65 8.14 8.14 8.14ZM28.72 33.32c0-6.3-6.27-11.4-13.99-11.4S.75 27.01.75 33.32",
    fill: "none",
    stroke: "#b3b3b3",
    strokeLinecap: "round",
    strokeWidth: "1.5px"
  }))));
};
export default SvgNavPerfil;